
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

const baseRef = 'cidades';
const route = {
  buscarMunicipio: (idUf: number) => `${baseRef}/${idUf}`
}

@Injectable({
  providedIn: 'root'
})
export class CidadeService {

  constructor(private apiService: ApiService) {

  }


  getCidadesByUf(idUf: number) {
    let params = new HttpParams().append('ignoreError','true');
    return this.apiService.get<any>(route.buscarMunicipio(idUf),params);
  }


}
